import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const createScheduleApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/shift`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateScheduleApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      BASE_URL + `v1/${STAGE}/dashboard/shift/${payload._id}`,
      {
        code: payload.code || undefined,
        timeIn: payload.timeIn || undefined,
        timeOut: payload.timeOut || undefined,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getScheduletApi = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/shift`
    );
    console.log("RESDAT", response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
